import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

interface StoredRoute {
    handle: DetachedRouteHandle;
    scrollPosition: number;
}

export class CustomReuseStrategy implements RouteReuseStrategy {
    handlers: { [key: string]: StoredRoute } = {};

    private getRouteKey(route: ActivatedRouteSnapshot): string | null {
        if (route.routeConfig && route.routeConfig.data && route.routeConfig.data['reuseKey']) {
            return route.routeConfig.data['reuseKey'];
        }
        if (route.data && route.data['reuseKey']) {
            return route.data['reuseKey'];
        }
        return null;
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        const routeKey = this.getRouteKey(route);
        return !!routeKey;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        const key = this.getRouteKey(route);
        if (key) {
            const scrollContainer = document.getElementById('scroll-container');
            const scrollPosition = scrollContainer ? scrollContainer.scrollTop : 0;
            this.handlers[key] = {
                handle: handle,
                scrollPosition: scrollPosition
            };
        }
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const key = this.getRouteKey(route);
        return key ? !!this.handlers[key] : false;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        const key = this.getRouteKey(route);
        if (key == null) {
            return null;
        }
        const stored = this.handlers[key];
        if (stored) {
            setTimeout(() => {
                const scrollContainer = document.getElementById('scroll-container');
                if (scrollContainer) {
                    scrollContainer.scrollTo(0, stored.scrollPosition);
                }
            }, 600);
            return stored.handle;
        }
        return null;

    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }
}
